import {Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ProjectConstants} from '../../project-constants';
import {FormControl} from '@angular/forms';
import {Subscription} from 'rxjs';
import {UserEmailFilterComponent} from './user-email-filter/user-email-filter.component';
import {UserNameFilterComponent} from './user-name-filter/user-name-filter.component';
import {UserSurnameFilterComponent} from './user-surname-filter/user-surname-filter.component';
import {UserModel} from '../../../models/UserModel';
import {UsersService} from '../service/users.service';
import {LoaderService} from 'src/app/general-services/service-loader/loader.service';
import {UserRoleFilterComponent} from './user-role-filter/user-role-filter.component';
import {UserUsernameFilterComponent} from './user-username-filter/user-username-filter.component';

@Component({
  selector: 'app-filter-user',
  templateUrl: './filter-user.component.html',
  styleUrls: ['./filter-user.component.scss']
})
export class FilterUserComponent extends ProjectConstants implements OnInit, OnDestroy {

  @Output() dataFiltered = new EventEmitter<any>();

  listUsernameFilter: any[];
  listNameFilter: any[];
  listSurnameFilter: any[];
  listEmailFilter: any[];
  listRoleFilter: any[];

  usernameFormControl = new FormControl();
  nameFormControl = new FormControl();
  surnameFormControl = new FormControl();
  emailFormControl = new FormControl();
  rolesFormControl = new FormControl();
  getAllSubsribe: Subscription;

  @ViewChild(UserUsernameFilterComponent, { static: true }) userUsernameFilterComponent;
  @ViewChild(UserEmailFilterComponent, { static: true }) userEmailFilterComponent;
  @ViewChild(UserNameFilterComponent, { static: true }) userNameFilterComponent;
  @ViewChild(UserSurnameFilterComponent, { static: true }) userSurnameFilterComponent;
  @ViewChild(UserRoleFilterComponent, { static: true }) userRoleFilterComponent;

  constructor(private usersService: UsersService, private loaderService: LoaderService) {
    super();
    this.loaderService.display(true);

  }

  ngOnInit() {
  }

  filterTable(): void {
    const filter = new UserModel();
    filter.username = this.userUsernameFilterComponent.usernamesFormControl.value ? this.userUsernameFilterComponent.usernamesFormControl.value.username : null;
    filter.name = this.userNameFilterComponent.namesFormControl.value ? this.userNameFilterComponent.namesFormControl.value.name : null;
    filter.surname = this.userSurnameFilterComponent.surnamesFormControl.value ? this.userSurnameFilterComponent.surnamesFormControl.value.surname : null;
    filter.idRole = this.userRoleFilterComponent.rolesFormControl.value ? this.userRoleFilterComponent.rolesFormControl.value.id : null;
    filter.mail = this.userEmailFilterComponent.emailFormControl.value ? this.userEmailFilterComponent.emailFormControl.value.mail : null;

    this.dataFiltered.emit(filter);
  }

  resetTable() {
    this.userUsernameFilterComponent.usernamesFormControl.setValue(null);
    this.userNameFilterComponent.namesFormControl.setValue(null);
    this.userSurnameFilterComponent.surnamesFormControl.setValue(null);
    this.userRoleFilterComponent.rolesFormControl.setValue(null);
    this.userEmailFilterComponent.emailFormControl.setValue(null);

    this.userUsernameFilterComponent.applyUserFormControlFilteredOptions();
    this.userNameFilterComponent.applyUserFormControlFilteredOptions();
    this.userSurnameFilterComponent.applyUserFormControlFilteredOptions();
    this.userEmailFilterComponent.applyUserFormControlFilteredOptions();

    this.filterTable();
  }

  getAll() {
    this.getAllSubsribe = this.usersService.getAll(this.usersService.baseUrl, null)
      .subscribe(
        (result: any) => {
          this.listUsernameFilter = result;
          this.listNameFilter = result;
          this.listSurnameFilter = result;
          this.listEmailFilter = result;
          this.listRoleFilter = result;
          this.usernameFormControl.setValue(null);
          this.nameFormControl.setValue(null);
          this.surnameFormControl.setValue(null);
          this.emailFormControl.setValue(null);
          this.rolesFormControl.setValue(null);
        }
      );
  }


  ngOnDestroy(): void {
  }

}
